// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Api, createApiData } from 'app/common/context/Api';


export const MenuCategories = createApiData();

const makeRequestsData = (id, t, schoolId) => (id ? {
  menuCategories: {
    path: 'cafeteria/customer/menu/items/categories',
    type: 'get',
    rest: { params: { customer_id: id, school_id: schoolId } },
    cbErrorTextCreate: (/* error */) => t(
      'menu_categories_fetch_error',
      'Не удалось получить категории меню столовой',
    ),
    autoRequest: true,
  },
} : {});

type State = {
  content: {
    categories: {
      [string]: {
        id: number,
        title: string,
        deleted: boolean,
      }
    }
  },
  loading: boolean,
  request: {
    menuCategories: (void) => Promise<void>,
  },
  error?: { [string]: mixed },
}

type Props = {
  personId?: number,
  children: React.Node | (value: State) => React.Node,
  schoolId?: number
}

const initialContent = {
  categories: {},
};

const MenuCategoriesApi = ({ children, personId, schoolId }: Props) => {
  const { t } = useTranslation('cafeteria');
  const descriptions = React.useMemo(() => makeRequestsData(personId, t, schoolId), [personId, t, schoolId]);

  return (
    <Api apiData={MenuCategories} descriptions={descriptions} initialContent={initialContent}>
      {children}
    </Api>
  );
};

export default MenuCategoriesApi;
